import request from '@/utils/request'
import api from '@/api/api'

export class Common {
  updateNotify(data) {
    return request({
      url: api.common.updateNotify,
      method: 'put',
      data
    })
  }
  getCommonData(params) {
    return request({
      url: api.common.getCommonData,
      method: 'get',
      params
    })
  }
  merchantVerify(data) {
    return request({
      url: api.common.merchantVerify,
      method: 'post',
      data
    })
  }
  getMerchantMsg(params) {
    return request({
      url: api.common.getMerchantMsg,
      method: 'get',
      params
    })
  }
  getFileUrl(data) {
    return request({
      url: api.common.getFileUrl,
      method: 'post',
      data
    })
  }
  // 商户多币种钱包列表查询
  merchantAccountQuery(params) {
    return request({
      url: api.common.merchantAccountQuery,
      method: 'get',
      params
    })
  }
  // 当前用户默认充值类型
  getDepositType(params) {
    return request({
      url: api.common.getDepositType,
      method: 'get',
      params
    })
  }
  // 汇率查询
  getExchangeRate(params) {
    return request({
      url: api.common.getExchangeRate,
      method: 'get',
      params
    })
  }
  // 计算商户充值金额(境内)
  depositCalculate(params) {
    return request({
      url: api.common.depositCalculate,
      method: 'get',
      params
    })
  }
  // 计算商户充值金额(境外)
  overseasDepositCalculate(params) {
    return request({
      url: api.common.overseasDepositCalculate,
      method: 'get',
      params
    })
  }
  // 查看商户设置
  getMerchantSetting(params) {
    return request({
      url: api.common.getMerchantSetting,
      method: 'get',
      params
    })
  }
  depositeCreate(data) {
    return request({
      url: api.common.depositeCreate,
      method: 'post',
      data
    })
  }
  // 充值凭证确认
  verifyCertificate(param,data) {
    return request({
      url: `${api.common.verifyCertificate}?depositId=${param}`,
      method: 'post',
      data
    })
  }
  getDepositMsg(params) {
    return request({
      url: api.common.getDepositMsg,
      method: 'get',
      params
    })
  }
  createSupplier(data) {
    return request({
      url: api.common.createSupplier,
      method: 'post',
      data
    })
  }
  // 快速创建供应商
  createSupplierQuick(data) {
    return request({
      url: api.common.createSupplierQuick,
      method: 'post',
      data
    })
  }
  
  querySupplierDetail(params) {
    return request({
      url: api.common.querySupplierDetail,
      method: 'get',
      params
    })
  }
  // 商户供应商列表
  querySupplierList(params) {
    return request({
      url: api.common.querySupplierList,
      method: 'get',
      params
    })
  }
  // 商户供应商列表分页查询
  querySuppliers(data) {
    return request({
      url: api.common.querySuppliers,
      method: 'post',
      data
    })
  }
  // 供应商van交易查询
  queryVanHistory(data) {
    return request({
      url: api.common.queryVanHistory,
      method: 'post',
      data
    })
  }
  createCard(data) {
    return request({
      url: api.common.createCard,
      method: 'post',
      data
    })
  }
  // 修改信用卡
  updateCard(data) {
    return request({
      url: api.common.updateCard,
      method: 'put',
      data
    })
  }
  queryCardDetail(params) {
    return request({
      url: api.common.queryCardDetail,
      method: 'get',
      params
    })
  }
  closeCard(params) {
    return request({
      url: api.common.closeCard,
      method: 'delete',
      params
    })
  }
  // 信用卡消费详情
  cardTransactionRecord(params) {
    return request({
      url: api.common.cardTransactionRecord,
      method: 'get',
      params
    })
  }
  // 虚拟信用卡列表
  queryAllCard(data) {
    return request({
      url: api.common.queryAllCard,
      method: 'post',
      data
    })
  }

  // 历史交易记录
  pageCardTransaction(data) {
    return request({
      url: api.common.pageCardTransaction,
      method: 'post',
      data
    })
  }

  // 历史交易记录
  exportCardTransaction(data) {
    return request({
      url: api.common.exportCardTransaction,
      method: 'post',
      data
    })
  }

  // 商户钱包充值记录
  rechargeRecord(data) {
    return request({
      url: api.common.rechargeRecord,
      method: 'post',
      data
    })
  }
  // 商户钱包交易明细
  walletTransationRecord(data) {
    return request({
      url: api.common.walletTransationRecord,
      method: 'post',
      data
    })
  }
  // 商户钱包详情
  queryAccountDetail(params) {
    return request({
      url: api.common.queryAccountDetail,
      method: 'get',
      params
    })
  }
  queryShortVan() {
    return request({
      url: api.common.queryShortVan,
      method: 'get'
    })
  }
  queryVan() {
    return request({
      url: api.common.queryVan,
      method: 'get'
    })
  }
  supplierUpload(data) {
    return request({
      url: api.common.supplierUpload,
      method: 'post',
      data
    })
  }
  sendEmail(params) {
    return request({
      url: api.common.sendEmail,
      method: 'put',
      params
    })
  }
  //  消息列表搜索
  queryMessageList(data) {
    return request({
      url: api.common.queryMessageList,
      method: 'post',
      data
    })
  }
  // 单条标记消息已读
  readMessage(params) {
    return request({
      url: api.common.readMessage,
      method: 'put',
      params
    })
  }
  // 标记所有消息已读
  readALLMessage(data) {
    return request({
      url: api.common.readALLMessage,
      method: 'put',
      data
    })
  }
  // 修改密码
  updatePassword(params) {
    return request({
      url: api.common.updatePassword,
      method: 'put',
      params
    })
  }
  // 修改账户信息
  updateBaseInfo(data) {
    return request({
      url: api.common.updateBaseInfo,
      method: 'put',
      data
    })
  }
  // 虚拟卡充值
  vanDeposit(data) {
    return request({
      url: api.common.vanDeposit,
      method: 'put',
      data
    })
  }
  // 查看获取API账户的User Id
  apiUserName(params) {
    return request({
      url: api.common.apiUserName,
      method: 'get',
      params
    })
  }
  // 查看获取API账户的新的密码
  apiPassword(params) {
    return request({
      url: api.common.apiPassword,
      method: 'get',
      params
    })
  }
  merchantUrl(params) {
    return request({
      url: api.common.merchantUrl,
      method: 'get',
      params
    })
  }
  // 供应商删除
  deleteSupplier(params) {
    return request({
      url: api.common.deleteSupplier,
      method: 'delete',
      params
    })
  }
}

